import React from "react";
import TitleHeading from "./TitleHeading";

// Main display component
interface StageInfoBoxDisplayProps {
    language?: string;
}

export default function StageInfoBoxDisplay({ language = 'it' }: StageInfoBoxDisplayProps) {

    const texts: any = {
        'title': {
            'en': 'Attention',
            'it': 'Attenzione',
        },
        'description': {
            'en': "This is a test environment. Do not use it in production.",
            'it': "Questo è un ambiente di test. Non utilizzare in produzione."
        }
    }

    return (
        <div className="rounded-2xl w-full max-w-lg pb-2 bg-white border-4 border-red-500">
            <div className="p-3 rounded-2xl max-w-lg">
                {/* Header with optional icon */}
                <div className="flex flex-col items-center mb-4">
                    <TitleHeading label={`!! ${texts['title'][language]} !!`} size="h2" className="text-center text-red-500" />
                </div>
                <div className="flex flex-col items-center px-2">
                    <TitleHeading label={texts['description'][language]} size="p" className="text-center" />
                </div>
            </div>
        </div>
    );
}
